module.exports = __webpack_public_path__ + "img/veg_carrot.9801986a.png";